import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '@modules/constants-enumerate';
import {deepAssign} from '@aofl/object-utils';

const sdo = {
  namespace: sdoNs.PARENT_INFO,
  mutations: {
    init() {
      return {
        id: null,
        first_name: null,
        last_name: null,
        type: null,
        phone: null,
        email: '',
        password: '',
        activationCode: '',
        roles: [],
        groups: [],
        students: [],
        productsForCode: [],
        new_activations: [],
        error_activations: [],
        success_activations: [],
      };
    },
    setData(subState, data) {
      return Object.assign({}, subState, {...data});
    },
  },
  decorators: [
    (nextState) => { // $productsForCode
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.PARENT_INFO];
      const subState = state[sdoNs.PARENT_INFO];
      if (
        typeof nextSubState.$productsForCode === 'undefined' ||
        nextSubState.productsForCode !== subState.productsForCode
      ) {
        const $productsForCode = [];
        nextSubState.productsForCode.map((product) => {
          $productsForCode.push(product.aofl_product);
        });

        nextState = deepAssign(nextState, sdoNs.PARENT_INFO, {
          $productsForCode
        });
      }

      return nextState;
    },
    (nextState) => { // $newActivations, $skipActivations
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.PARENT_INFO];
      const subState = state[sdoNs.PARENT_INFO];
      if (
        typeof nextSubState.$newActivations === 'undefined' ||
        nextSubState.new_activations !== subState.new_activations
      ) {
        const $newActivations = [];
        const $skipActivations = [];
        for (let i = 0; i < nextSubState.new_activations.length; i++) {
          // on first login try to activate conflict items again
          if (!nextSubState.firstLogin && nextSubState.new_activations[i].activation_status === 'conflict') {
            $skipActivations.push(nextSubState.new_activations[i]);
          } else {
            $newActivations.push(nextSubState.new_activations[i]);
          }
        }

        nextState = deepAssign(nextState, sdoNs.PARENT_INFO, {
          $newActivations,
          $skipActivations
        });
      }

      return nextState;
    },
  ]
};

storeInstance.addState(sdo);
